var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.66602C4.45785 6.66602 2.66699 8.45688 2.66699 10.666V21.3327C2.66699 23.5418 4.45785 25.3327 6.66699 25.3327H18.667C20.4705 25.3327 21.9953 24.1391 22.4944 22.4987M22.667 15.9993L27.5127 11.1536C28.0839 10.5824 28.3695 10.2968 28.6147 10.2775C28.8274 10.2608 29.0353 10.3469 29.1739 10.5092C29.3337 10.6962 29.3337 11.1001 29.3337 11.9078V20.0909C29.3337 20.8986 29.3337 21.3025 29.1739 21.4895C29.0353 21.6518 28.8274 21.7379 28.6147 21.7212C28.3695 21.7019 28.0839 21.4163 27.5127 20.8451L22.667 15.9993ZM22.667 15.9993V13.066C22.667 10.8258 22.667 9.7057 22.231 8.85005C21.8475 8.09741 21.2356 7.48548 20.483 7.10199C19.6273 6.66602 18.5072 6.66602 16.267 6.66602H12.667M2.66699 2.66602L29.3337 29.3327",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoMute);
export default __webpack_public_path__ + "static/media/IconVideoMute.24128663916dec133951fd0dee90c87f.svg";
export { ForwardRef as ReactComponent };